<template>
    <div class="center">
        <p class="black fs32 fw500">{{ $t('renew7') }}</p>
        <span class="backyel dib divide"></span>
        <div class="p1">
            <p class="gray fs18 mb40">
                {{ $t('renew2') }}
            </p>
            <div :class="$style.wrapper">
                <div class="mb40">
                    <p class="fs24 mb40">{{$t("renew1").toUpperCase()}}</p>
                    <img src="../assets/renew.png" alt="" :class="$style.pic" class="biggerpic cp" @click="$router.push('/renew/5')">
                </div>
                <div class="mb40">
                    <p class="fs24 mb40">{{$t("p18").toUpperCase()}}</p>
                    <img src="../assets/renew.png" alt="" :class="$style.pic" class="biggerpic cp" @click="$router.push('/renew/6')">
                </div>
				<div class="mb40">
				    <p class="fs24 mb40">{{$t("p19").toUpperCase()}}</p>
				    <img src="../assets/renew.png" alt="" :class="$style.pic" class="biggerpic cp" @click="$router.push('/payment/4')">
				</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OnlineRenew',
     created() {
        this.$top();
    }
}
</script>
<style module>
.pic {
    width: 60%;
}
.wrapper {
    display: flex;
}
@media screen and (max-width: 770px) {
    .pic {
        width: 70%;
    }
    .wrapper {
        display: block;
    }
}
</style>
